import { ChangeDetectionStrategy, Component } from '@angular/core';
import IuAiChatComponent from '@iupics-components/specific/ai-chat/components/iu-ai-chat/iu-ai-chat.component';
import SpecificWindowUiComponent from '../specific-window-ui/specific-window-ui.component';

@Component({
  selector: 'iu-ai-chat-window-ui',
  standalone: true,
  imports: [IuAiChatComponent],
  templateUrl: './ai-chat-window-ui.component.html',
  styleUrl: './ai-chat-window-ui.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class AiChatWindowUiComponent extends SpecificWindowUiComponent {}
